import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {ButtonData} from '../mapping-classes/button-data';
import {formatCurrency} from '@angular/common';

export class Rekeningcourant implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;
  administrationCode: string;

  constructor(response: any) {
    this.title = 'Rekening Courant';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.productDescription || this.title;
      this.actualityDateTime = response.detailsViewObject.profileCreationTime;
      this.setAdministrationCode(response.detailsViewObject.rekeningnummer.replace(/\s+/g, ''));
      this.addButtons(response);
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues(response);
      this.addValues(response);
    }
  }

  setAdministrationCode(arrangementNumber: string) {
    if (arrangementNumber.includes("EUR")) {
      this.administrationCode = "01";
    } else {
      this.administrationCode = "28";
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Rente / Provisie / Kosten'));
  }

  private addButtons(response) {
    this.buttons.push(new ButtonData('productservicesurl',
      response.detailsViewObject.rekeningnummer.replace(/\s+/g, '').substring(9, 18),
      this.administrationCode, null, 'Productservice', null));

    let arrangementNumber = response.detailsViewObject.rekeningnummer.replace(/\s+/g, '').substring(9, 18);
    if (this.administrationCode == "28") {
      const len = response.detailsViewObject.rekeningnummer.length;
      const currency = response.detailsViewObject.rekeningnummer.substring(len - 4, len - 1);
      arrangementNumber = arrangementNumber + currency;
    }

    this.buttons.push(new ButtonData('cockpiturl', arrangementNumber,
      this.administrationCode, null, 'B&O Cockpit', null, 'boc-url', null));
  }

  setNameAndValues(response?) {
    const productDetailsPanel: DetailPanel = this.panels[0];
    const productAgreements:  DetailPanel = this.panels[1];
    const productUse:  DetailPanel = this.panels[2];

    this.fillProductDetailsPanel(productDetailsPanel);
    this.fillProductAgreementsPanel(productAgreements);
    this.fillProductUsePanel(productUse);
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    const productAgreementsPanel: DetailPanel = this.panels[1];
    const productUsePanel: DetailPanel = this.panels[2];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);
    this.addValuesToProductAgreementsPanel(productAgreementsPanel, obj);
    this.addValuesToProductUsePanel(productUsePanel, obj);
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('iban', new DetailLabel('Rekeningnummer'));
    productDetailsPanel.nameAndValues.set('productName', new DetailLabel('Product'));
    productDetailsPanel.nameAndValues.set('accountStatus', new DetailLabel('Status'));
    productDetailsPanel.nameAndValues.set('saldo', new DetailLabel('Actueel Saldo'));
    productDetailsPanel.nameAndValues.set('description', new DetailLabel('Rekeningomschrijving klant'));
    productDetailsPanel.nameAndValues.set('abb', new DetailLabel('ABB code'));
    productDetailsPanel.nameAndValues.set('productLocation', new DetailLabel('Productlocatie'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('iban').setValue(obj.rekeningnummer || '-');
    productDetailsPanel.nameAndValues.get('productName').setValue(obj.productDescription || '-');
    productDetailsPanel.nameAndValues.get('accountStatus').setValue(obj.status || '-');
    productDetailsPanel.nameAndValues.get('saldo').setValue(this.formatActualBalance(obj));
    productDetailsPanel.nameAndValues.get('description').setValue(obj.rekeningomschrijvingKlant || '-');
    productDetailsPanel.nameAndValues.get('abb').setValue(obj.abbCode || '-');
    productDetailsPanel.nameAndValues.get('productLocation').setValue(obj.productlocatie || '-');
  }

  private fillProductAgreementsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('dateOfOrigin', new DetailLabel('Datum ontstaan'));
    productDetailsPanel.nameAndValues.set('creditAmount', new DetailLabel('Kredit Bedrag'));
    productDetailsPanel.nameAndValues.set('dateOfDissolution', new DetailLabel('Datum opheffing'));
    productDetailsPanel.nameAndValues.set('securityCode', new DetailLabel('Zekerheidscode'));
    productDetailsPanel.nameAndValues.set('raFrequency', new DetailLabel('Frequentie RA'));
    productDetailsPanel.nameAndValues.set('autoDirectDebitListingPopup', new DetailLabel('Blokkade-/Goedkeuringslijst Euro-incasso'));
    productDetailsPanel.nameAndValues.set('automaticContainment', new DetailLabel('Automatisch inperken'));
    productDetailsPanel.nameAndValues.set('discountScheme', new DetailLabel('Kortingsregeling'));
    productDetailsPanel.nameAndValues.set('mandatesPopup', new DetailLabel('Machtigingen Euro-incasso'));
    productDetailsPanel.nameAndValues.set('creditCurtailment', new DetailLabel('Bedrag kredietinperking'));
    productDetailsPanel.nameAndValues.set('periodOfCreditContainment', new DetailLabel('Periode kredietinperking'));
    productDetailsPanel.nameAndValues.set('dateOfNextCurtailment', new DetailLabel('Datum volgende inperking'));
  }

  private addValuesToProductAgreementsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('dateOfOrigin').setValue((obj.datumOntstaan) ? obj.datumOntstaan.substring(0, 10) : '-');
    productDetailsPanel.nameAndValues.get('creditAmount').setValue(
      (obj.kredietbedrag ? formatCurrency(obj.kredietbedrag.value, 'nl', '€') : '-'));
    productDetailsPanel.nameAndValues.get('dateOfDissolution').setValue((obj.datumOpheffing) ? obj.datumOpheffing : '-');
    productDetailsPanel.nameAndValues.get('securityCode').setValue(obj.zekerheidscode || '-');
    productDetailsPanel.nameAndValues.get('raFrequency').setValue(obj.frequentieRaTranslated || '-');
    productDetailsPanel.nameAndValues.get('autoDirectDebitListingPopup').setValue('Blokkade-/Goedkeuringslijst');
    productDetailsPanel.nameAndValues.get('automaticContainment').setValue(obj.automatischInperken || '-');
    productDetailsPanel.nameAndValues.get('discountScheme').setValue((obj.kortingsregeling) ? obj.kortingsregeling : '-');
    productDetailsPanel.nameAndValues.get('mandatesPopup').setValue('Machtigingen');
    productDetailsPanel.nameAndValues.get('creditCurtailment').setValue(
      (obj.bedragKredietinperking ? formatCurrency(obj.bedragKredietinperking.value, 'nl', '€') : '-'));
    productDetailsPanel.nameAndValues.get('periodOfCreditContainment').setValue(obj.periodeKredietinperking || '-');
    productDetailsPanel.nameAndValues.get('dateOfNextCurtailment').setValue(
      (obj.datumVolgendeInperking) ? obj.datumVolgendeInperking.substring(0, 10) : '-');
  }

  private fillProductUsePanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('settlementAccountNumber', new DetailLabel('Afreken rekeningnummer'));
    productDetailsPanel.nameAndValues.set('settlementCode', new DetailLabel('Afrekencode RPK'));
    productDetailsPanel.nameAndValues.set('settlementPeriodRP', new DetailLabel('Afrekenperiode RP'));
    productDetailsPanel.nameAndValues.set('settlementPeriodK', new DetailLabel('Afrekenperiode K'));
    productDetailsPanel.nameAndValues.set('interestCompensation', new DetailLabel('Rentecompensatie'));
    productDetailsPanel.nameAndValues.set('balanceCompensation', new DetailLabel('Saldocompensatie'));
    productDetailsPanel.nameAndValues.set('debitInterestPopup', new DetailLabel('Debetrente afspraak'));
    productDetailsPanel.nameAndValues.set('creditInterestPopup', new DetailLabel('Creditrente afspraak'));
    productDetailsPanel.nameAndValues.set('debitCalculationMethod', new DetailLabel('Berekeningsmethode Dt'));
    productDetailsPanel.nameAndValues.set('creditCalculationMethod', new DetailLabel('Berekeningsmethode Cr'));
    productDetailsPanel.nameAndValues.set('commissionAgreement', new DetailLabel('Provisie afspraak'));
    productDetailsPanel.nameAndValues.set('basisPercentage', new DetailLabel('Percentage grondslag'));
    productDetailsPanel.nameAndValues.set('costsAgreement', new DetailLabel('Kosten afspraak'));
    productDetailsPanel.nameAndValues.set('threshold', new DetailLabel('Drempel/schijf'));
  }

  private addValuesToProductUsePanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('settlementAccountNumber').setValue(obj.afrekenRekeningnummer || '-');
    productDetailsPanel.nameAndValues.get('settlementCode').setValue(obj.afrekenomschrijvingRPK || '-');
    productDetailsPanel.nameAndValues.get('settlementPeriodRP').setValue(obj.afrekenperiodeRP || '-');
    productDetailsPanel.nameAndValues.get('settlementPeriodK').setValue(obj.afrekenperiodeK || '-');
    productDetailsPanel.nameAndValues.get('interestCompensation').setValue(obj.rentecompensatie || '-');
    productDetailsPanel.nameAndValues.get('balanceCompensation').setValue(obj.saldocompensatie || '-');
    productDetailsPanel.nameAndValues.get('debitInterestPopup').setValue(obj.debetrentAfspraak || '-');
    productDetailsPanel.nameAndValues.get('creditInterestPopup').setValue(obj.afspraakCreditRente || '-');
    productDetailsPanel.nameAndValues.get('debitCalculationMethod').setValue(obj.berekeningsmethodeDT || '-');
    productDetailsPanel.nameAndValues.get('creditCalculationMethod').setValue(obj.afspraakBerekeningsmethodeCR || '-');
    productDetailsPanel.nameAndValues.get('commissionAgreement').setValue(obj.provisieAfspraak || '-');
    productDetailsPanel.nameAndValues.get('basisPercentage').setValue(obj.afspraakPercentageGrondslag || '-');
    productDetailsPanel.nameAndValues.get('costsAgreement').setValue(obj.kostenAfspraak || '-');
    productDetailsPanel.nameAndValues.get('threshold').setValue(obj.afspraakDrempelSchijf || '-');
  }

  formatActualBalance(obj: any) {
    if (obj.actueelSaldo === null) {
      return '-';
    }

    const len = obj.rekeningnummer.length;
    const currency = obj.rekeningnummer.substring(len - 4, len - 1);

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(obj.actueelSaldo) + " " + (obj.balanceIndicator ? obj.balanceIndicator : "");
  }
}
